import dayjs from 'dayjs';

export default function (app, env) {
    app.config.globalProperties.$dayjs = dayjs;
}